import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractSpecificFieldComponent } from '../abstract-specific-field.component';

@Component({
    selector: 'app-specific-comment',
    templateUrl: './specific-comment.component.html',
    styleUrls: ['./specific-comment.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpecificCommentComponent extends AbstractSpecificFieldComponent<string> {
  override getDataName(): string {
    return 'commentaire';
  }

  override wrapData(value: string): string {
    return value;
  }
  override markAsTouched(): void {
    this.control.markAsTouched();
  }
}
